import axios from "@/utils/api-v1"

export default {
  getConversations(params) {
    return axios.get("/api/conversations", { params })
  },

  getConversation(id) {
    return axios.get(`/api/conversations/${id}`)
  },

  getOrCreateThread(userId) {
    return axios.post("/api/conversations/thread", { recipientId: userId })
  },

  getThreadWith(userId) {
    return axios.get(`/api/conversations/with/${userId}`)
  },

  archiveConversation(id) {
    return axios.patch(`/api/conversations/${id}/archive`)
  },

  markRead(id) {
    return axios.patch(`/api/conversations/${id}/mark-read`)
  },

  sendMessage(conversationId, body) {
    return axios.post("/api/messages", { conversationId, body })
  },

  getUnreadCount() {
    return axios.get("/api/messages/unread-count")
  },
}
